// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `ion-menu {
  /* Para que ocupe todo el ancho si se necesita */
  height: 100%;
  background: rgba(0, 0, 0, 0.5);
}
ion-menu ion-header ion-toolbar {
  --min-height: 34px;
}
ion-menu ion-footer ion-toolbar {
  --padding-top: 0;
  --background: none;
}
ion-menu ion-footer ion-toolbar ion-item:last-child {
  --background: var(--boxx-app-background, var(--ion-color-primary));
  max-height: 56px;
}

ion-menu[menuId=help-menu] ion-item {
  --detail-icon-font-size: 16px;
  --detail-icon-opacity: 1;
  --detail-icon-color: var(--ion-color-default-text);
  --background: var(--ion-color-primary);
  --border-color: var(--ion-color-default-text);
  color: var(--ion-color-default-text);
}
ion-menu[menuId=help-menu] ion-item ion-button ion-icon {
  color: var(--ion-color-default-text);
}
ion-menu[menuId=help-menu] ion-item ion-label {
  color: var(--ion-color-default-text);
}
ion-menu[menuId=help-menu] ion-item ion-label#appversion {
  margin-right: 0;
  color: var(--ion-color-medium);
}
ion-menu[menuId=help-menu] ion-item a {
  border-color: white !important;
  --border-color: white !important;
}
ion-menu[menuId=help-menu] ion-item.branding-picker ion-label {
  color: var(--ion-color-primary-contrast) !important;
}
ion-menu[menuId=help-menu] ion-item.branding-picker ion-select {
  --placeholder-opacity: 1;
}
ion-menu[menuId=help-menu] ion-icon {
  color: var(--ion-color-primary-contrast);
  --boxx-custom-icon-fill: var(--ion-color-primary);
}
ion-menu[menuId=help-menu] ion-menu-toggle ion-button {
  margin-left: 0;
  --padding-start: 0;
}
ion-menu[menuId=help-menu] ion-menu-toggle ion-icon {
  color: var(--ion-color-dark);
}

ion-menu[menuId=main-content-menu] {
  --backdrop-opacity: 1;
  --boxx-menu-top-background-color: var(--ion-color-light, blue);
  --boxx-menu-top-font-color: var(--ion-color-primary, red);
  --boxx-menu-bottom-background-color: var(--ion-color-light, white);
  --boxx-menu-bottom-font-color: var(--ion-color-primary, white);
  /* #menu-entry-3 {
    display: none;
  } */
}
ion-menu[menuId=main-content-menu] ion-header ion-toolbar {
  --background: var(--boxx-app-background, var(--ion-color-primary));
}
ion-menu[menuId=main-content-menu] ion-icon.min-margin {
  margin-right: 16px;
}
ion-menu[menuId=main-content-menu] ion-content #menu-back-btn {
  color: var(--ion-text-color);
}
ion-menu[menuId=main-content-menu] ion-content ion-list ion-menu-toggle:first-child ion-item {
  --background: var(--boxx-app-background, var(--ion-color-primary));
}
ion-menu[menuId=main-content-menu] ion-content ion-list ion-menu-toggle ion-item {
  margin-right: 0 !important;
  color: var(--ion-color-dark);
}
ion-menu[menuId=main-content-menu] ion-content ion-list ion-menu-toggle ion-item ion-icon {
  --boxx-custom-icon-fill: white;
}
ion-menu[menuId=main-content-menu] ion-content #version-number {
  font-size: 12px;
  font-weight: 500;
  color: var(--ion-color-medium);
}
ion-menu[menuId=main-content-menu] ion-footer ion-toolbar ion-item:last-child {
  --background: var(--boxx-app-background, var(--ion-color-primary));
}

#menu-list {
  padding-top: env(safe-area-inset-top) !important;
}
#menu-list .item-user {
  --padding-start: 16px;
}
#menu-list .item-user ion-avatar {
  margin-right: 12px;
}
#menu-list .item-user .username {
  color: var(--text-Subtitles, #13011D);
  font-feature-settings: "liga" off, "clig" off;
  font-family: Poppins;
  font-size: 16px;
  font-style: normal;
  font-weight: 500;
  line-height: normal;
}
#menu-list .item-user .email {
  color: var(--text-Subtitles, #13011D);
  font-feature-settings: "liga" off, "clig" off;
  font-family: Poppins;
  font-size: 12px;
  font-style: normal;
  font-weight: 400;
  line-height: normal;
}
#menu-list .content-item-menu {
  display: flex;
  justify-content: flex-start;
  align-items: center;
  padding: 0px 16px;
}
#menu-list .content-item-menu ion-icon {
  width: 24px;
  height: 24px;
}
#menu-list .content-item-menu ion-item {
  --padding-start: 10px;
  margin-bottom: 3px;
  width: 100%;
  --padding-end: 6px;
}
#menu-list .content-item-menu .arrow-icon-menu {
  margin: 15px 0px;
  color: var(--ion-color-primary);
}
#menu-list .icon-close-menu {
  width: 40px;
  height: 40px;
  position: relative;
  top: 16px;
  right: 16px;
  z-index: 9;
}
#menu-list .content-detail-menu {
  padding-left: 28px;
}
#menu-list ion-accordion-group .item-accordion {
  --padding-start: 16px;
}
#menu-list ion-accordion-group .item-accordion ion-icon {
  margin: 0px 8px 0px 0px;
}

#content-menu {
  --background: #ffffff;
}

@media (min-width: 960px) {
  ion-menu.side-menu {
    --width: 414px;
  }
}`, "",{"version":3,"sources":["webpack://./src/app/app.component.scss"],"names":[],"mappings":"AAAA;EAEE,gDAAA;EACA,YAAA;EAEA,8BAAA;AADF;AAII;EACE,kBAAA;AAFN;AAOI;EACE,gBAAA;EACA,kBAAA;AALN;AAOM;EACE,kEAAA;EACA,gBAAA;AALR;;AAYE;EACE,6BAAA;EACA,wBAAA;EACA,kDAAA;EACA,sCAAA;EACA,6CAAA;EACA,oCAAA;AATJ;AAYM;EACE,oCAAA;AAVR;AAcI;EACE,oCAAA;AAZN;AAeI;EACE,eAAA;EACA,8BAAA;AAbN;AAgBI;EACE,8BAAA;EACA,gCAAA;AAdN;AAkBM;EACE,mDAAA;AAhBR;AAmBM;EACE,wBAAA;AAjBR;AAsBE;EACE,wCAAA;EAGA,iDAAA;AAtBJ;AA0BI;EACE,cAAA;EACA,kBAAA;AAxBN;AA2BI;EACE,4BAAA;AAzBN;;AA8BA;EACE,qBAAA;EACA,8DAAA;EACA,yDAAA;EAEA,kEAAA;EACA,8DAAA;EAQA;;KAAA;AAjCF;AA4BI;EACE,kEAAA;AA1BN;AAkCE;EACE,kBAAA;AAhCJ;AAsCI;EACE,4BAAA;AApCN;AA0CU;EACE,kEAAA;AAxCZ;AA4CQ;EACE,0BAAA;EACA,4BAAA;AA1CV;AA4CU;EAGE,8BAAA;AA5CZ;AAkDI;EACE,eAAA;EACA,gBAAA;EACA,8BAAA;AAhDN;AAsDM;EACE,kEAAA;AApDR;;AA2DA;EACE,gDAAA;AAxDF;AA0DE;EACE,qBAAA;AAxDJ;AA0DI;EACE,kBAAA;AAxDN;AA2DI;EACE,qCAAA;EACA,6CAAA;EACA,oBAAA;EACA,eAAA;EACA,kBAAA;EACA,gBAAA;EACA,mBAAA;AAzDN;AA4DI;EACE,qCAAA;EACA,6CAAA;EACA,oBAAA;EACA,eAAA;EACA,kBAAA;EACA,gBAAA;EACA,mBAAA;AA1DN;AA8DE;EACE,aAAA;EACA,2BAAA;EACA,mBAAA;EACA,iBAAA;AA5DJ;AA8DI;EACE,WAAA;EACA,YAAA;AA5DN;AA+DI;EACE,qBAAA;EACA,kBAAA;EACA,WAAA;EACA,kBAAA;AA7DN;AAgEI;EACE,gBAAA;EACA,+BAAA;AA9DN;AAkEE;EACE,WAAA;EACA,YAAA;EACA,kBAAA;EACA,SAAA;EACA,WAAA;EACA,UAAA;AAhEJ;AAmEE;EACE,kBAAA;AAjEJ;AAqEI;EACE,qBAAA;AAnEN;AAqEM;EACE,uBAAA;AAnER;;AAyEA;EACE,qBAAA;AAtEF;;AA0EA;EACE;IACE,cAAA;EAvEF;AACF","sourcesContent":["ion-menu {\n  //--width: 100%;\n  /* Para que ocupe todo el ancho si se necesita */\n  height: 100%;\n\n  background: rgba(0, 0, 0, 0.5);\n\n  ion-header {\n    ion-toolbar {\n      --min-height: 34px;\n    }\n  }\n\n  ion-footer {\n    ion-toolbar {\n      --padding-top: 0;\n      --background: none;\n\n      ion-item:last-child {\n        --background: var(--boxx-app-background, var(--ion-color-primary));\n        max-height: 56px;\n      }\n    }\n  }\n}\n\nion-menu[menuId=\"help-menu\"] {\n  ion-item {\n    --detail-icon-font-size: 16px;\n    --detail-icon-opacity: 1;\n    --detail-icon-color: var(--ion-color-default-text);\n    --background: var(--ion-color-primary);\n    --border-color: var(--ion-color-default-text);\n    color: var(--ion-color-default-text);\n\n    ion-button {\n      ion-icon {\n        color: var(--ion-color-default-text);\n      }\n    }\n\n    ion-label {\n      color: var(--ion-color-default-text);\n    }\n\n    ion-label#appversion {\n      margin-right: 0;\n      color: var(--ion-color-medium);\n    }\n\n    a {\n      border-color: white !important;\n      --border-color: white !important;\n    }\n\n    &.branding-picker {\n      ion-label {\n        color: var(--ion-color-primary-contrast) !important;\n      }\n\n      ion-select {\n        --placeholder-opacity: 1;\n      }\n    }\n  }\n\n  ion-icon {\n    color: var(--ion-color-primary-contrast);\n    // For the dots in the chatbubble icon\n    // chat bubble icon was customized to accept this variable :)\n    --boxx-custom-icon-fill: var(--ion-color-primary);\n  }\n\n  ion-menu-toggle {\n    ion-button {\n      margin-left: 0;\n      --padding-start: 0;\n    }\n\n    ion-icon {\n      color: var(--ion-color-dark);\n    }\n  }\n}\n\nion-menu[menuId=\"main-content-menu\"] {\n  --backdrop-opacity: 1;\n  --boxx-menu-top-background-color: var(--ion-color-light, blue);\n  --boxx-menu-top-font-color: var(--ion-color-primary, red);\n\n  --boxx-menu-bottom-background-color: var(--ion-color-light, white);\n  --boxx-menu-bottom-font-color: var(--ion-color-primary, white);\n\n  ion-header {\n    ion-toolbar {\n      --background: var(--boxx-app-background, var(--ion-color-primary));\n    }\n  }\n\n  /* #menu-entry-3 {\n    display: none;\n  } */\n\n  ion-icon.min-margin {\n    margin-right: 16px;\n  }\n\n  ion-content {\n\n    // --background: url(\"/assets/icon/Ornamentet_SplashBrand.svg\") 0 -24px no-repeat;\n    #menu-back-btn {\n      color: var(--ion-text-color);\n    }\n\n    ion-list {\n      ion-menu-toggle {\n        &:first-child {\n          ion-item {\n            --background: var(--boxx-app-background, var(--ion-color-primary));\n          }\n        }\n\n        ion-item {\n          margin-right: 0 !important;\n          color: var(--ion-color-dark);\n\n          ion-icon {\n            // For the dots in the chatbubble icon\n            // chat bubble icon was customized to accept this variable :)\n            --boxx-custom-icon-fill: white;\n          }\n        }\n      }\n    }\n\n    #version-number {\n      font-size: 12px;\n      font-weight: 500;\n      color: var(--ion-color-medium);\n    }\n  }\n\n  ion-footer {\n    ion-toolbar {\n      ion-item:last-child {\n        --background: var(--boxx-app-background, var(--ion-color-primary));\n      }\n    }\n  }\n}\n\n\n#menu-list {\n  padding-top: env(safe-area-inset-top) !important;\n\n  .item-user {\n    --padding-start: 16px;\n\n    ion-avatar {\n      margin-right: 12px;\n    }\n\n    .username {\n      color: var(--text-Subtitles, #13011D);\n      font-feature-settings: 'liga' off, 'clig' off;\n      font-family: Poppins;\n      font-size: 16px;\n      font-style: normal;\n      font-weight: 500;\n      line-height: normal;\n    }\n\n    .email {\n      color: var(--text-Subtitles, #13011D);\n      font-feature-settings: 'liga' off, 'clig' off;\n      font-family: Poppins;\n      font-size: 12px;\n      font-style: normal;\n      font-weight: 400;\n      line-height: normal;\n    }\n  }\n\n  .content-item-menu {\n    display: flex;\n    justify-content: flex-start;\n    align-items: center;\n    padding: 0px 16px;\n\n    ion-icon {\n      width: 24px;\n      height: 24px;\n    }\n\n    ion-item {\n      --padding-start: 10px;\n      margin-bottom: 3px;\n      width: 100%;\n      --padding-end: 6px;\n    }\n\n    .arrow-icon-menu {\n      margin: 15px 0px;\n      color: var(--ion-color-primary);\n    }\n  }\n\n  .icon-close-menu {\n    width: 40px;\n    height: 40px;\n    position: relative;\n    top: 16px;\n    right: 16px;\n    z-index: 9;\n  }\n\n  .content-detail-menu {\n    padding-left: 28px;\n  }\n\n  ion-accordion-group {\n    .item-accordion {\n      --padding-start: 16px;\n\n      ion-icon {\n        margin: 0px 8px 0px 0px;\n      }\n    }\n  }\n}\n\n#content-menu {\n  --background: #ffffff;\n}\n\n//PWA\n@media (min-width: 960px) {\n  ion-menu.side-menu {\n    --width: 414px;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
